module.exports = "/images/london-17.jpg";